module.exports = __webpack_public_path__ + "img/Francois Murisiersm.e1f2d6e5.jpg";